import { ApiErrorCodeEnum } from '../../../enums/api-error-code.enum';
import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';

/**
 * Record delete result DTO
 */
export class RecordDeleteResultDto<T> {
	/**
	 * An array of table names that are blocking the deletion.
	 */
	dependencies?: AppSubjectEnum[];

	/**
	 * The error code of the response. Defaults to OK.
	 */
	errorCode: ApiErrorCodeEnum = ApiErrorCodeEnum.OK;

	/**
	 * The data of the record that was deleted, if applicable.
	 */
	data?: T;
}
